module.exports = __webpack_public_path__ + "assets/img/language_img.4973986f.png";